/**
 * 認証を通さない公開ルート（#1313）。
 *
 * AuthProvider はマウント時にプロフィール取得などを走らせ、未ログインならログインへ
 * 飛ばす。公開申込フォームは顧客が未ログインで開くので、この配列のパスだけ
 * AuthProvider と Layout（サイドバー等の店舗UI）の外に出す。
 *
 * **ここに足す＝認証を外す**なので追加は慎重に。_app.tsx から分けてあるのは、
 * 判定だけをテストから読めるようにするため（_app.tsx は firebase 初期化を引き込む）。
 */
export const PUBLIC_PATHS = ["/apply"];

/** 完全一致、またはその配下（`/apply/verify` 等）を公開とみなす。 */
export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
